import { api as wiredApi } from './index';

/**
 * What a rider earned and owes, on InGo's API (ingo-e0, 2 Oct 2026; InGo ADR
 * 0030): read from the commission line written once at each completion,
 * never worked out here. The old screens added up Supabase's bookings and took
 * the commission off in the browser at today's rate.
 *
 * Built from its client so a test can hand it a fake; `earningsApi` is the
 * wired copy.
 *
 * The app only reads (Rio, 11 Oct 2026: *"make sure this won't affect us when
 * submitting our app to google play store"*): a deposit is paid at the
 * office, a payout is sent by it, and the office records both. "I've paid the
 * office" left with InGo ADR 0052; its route stays for older apps.
 */
export function createEarnings({ api }) {
  return {
    /**
     * `GET rider/me/earnings?period=today|week|month`: the period in the
     * operator's calendar, its totals in minor units, and each delivery's
     * fare, commission and what the rider kept, newest first.
     */
    async earnings(period) {
      const { data } = await api.get('/rider/me/earnings', { query: { period } });

      return data;
    },

    /**
     * `GET rider/me/balance` (InGo ADR 0052): the rider's money with InGo,
     * read from their ledger. Positive, InGo owes them; below zero, they owe
     * InGo. What is held and for how many days, what the office may pay now,
     * and the credit limit with whether they are over it.
     */
    async balance() {
      const { data } = await api.get('/rider/me/balance');

      return data;
    },

    /**
     * `GET rider/me/balance/lines`: the statement, newest first, a page at a
     * time; `before` is the cursor the last page gave (`next`).
     */
    async balanceLines(before = null) {
      const { data, meta } = await api.get('/rider/me/balance/lines', before ? { query: { before } } : undefined);

      return { lines: data?.lines ?? [], next: meta?.cursor?.next ?? null };
    },
  };
}

export const earningsApi = createEarnings({ api: wiredApi });
